import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuPortal,
} from "@suraasa/placebo-ui"

const ContentDropdownMenu = ({
  triggerButtonSlot,
  children,
}: {
  triggerButtonSlot: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <DropdownMenu>
      {triggerButtonSlot}
      <DropdownMenuPortal>
        <DropdownMenuContent
          sideOffset={10}
          // ClassName overrides required for hover/focus styles — do not remove
          className="rounded-md border border-onSurface-200 bg-surface shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out [&_[data-radix-collection-item]:hover]:bg-onSurface-100 [&_[data-radix-collection-item]:hover]:text-onSurface-900"
        >
          {children}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  )
}

export default ContentDropdownMenu
